import { Typography, Grid, Box, SxProps, Theme } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";
import { Card } from "../../modules";

export const Services = () => {
  return (
    <SectionContainer sx={{ background: "white" }}>
      <SectionTitle>サービス対象と対応範囲</SectionTitle>
      <SectionSubtitle>主要なクラウドプラットフォームに対応し、包括的な運用サポートを提供</SectionSubtitle>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={serviceItemSx}>
            <Box sx={serviceHeaderSx}>
              <Box sx={{ ...serviceLogoSx, ...awsLogoSx } as SxProps<Theme>}>AWS</Box>
              <Box>
                <Card.Title sx={{ marginBottom: "4px" }}>Amazon Web Services</Card.Title>
                <Typography variant="body2" sx={serviceSubtitleSx}>
                  Amazonのクラウドコンピューティングサービス
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={serviceDescriptionSx}>
              EC2、RDS、S3など、AWS全般のサービス監視・運用に対応。
              <br />
              「EC2でログインできなくなりました」といった問い合わせに対して、原因調査から解決策の提案・実施、再発防止策まで一貫対応します。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={serviceItemSx}>
            <Box sx={serviceHeaderSx}>
              <Box sx={{ ...serviceLogoSx, ...azureLogoSx } as SxProps<Theme>}>Azure</Box>
              <Box>
                <Card.Title sx={{ marginBottom: "4px" }}>Microsoft Azure</Card.Title>
                <Typography variant="body2" sx={serviceSubtitleSx}>
                  マイクロソフトの企業向けクラウドプラットフォーム
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={serviceDescriptionSx}>
              Virtual Machines、SQL Database、App Serviceなど、Azure環境の包括的な監視・運用を実施。
              <br />
              エンタープライズ環境での豊富な運用経験を活かしたサポートを提供します。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={serviceItemSx}>
            <Box sx={serviceHeaderSx}>
              <Box sx={{ ...serviceLogoSx, ...gcpLogoSx } as SxProps<Theme>}>GCP</Box>
              <Box>
                <Card.Title sx={{ marginBottom: "4px" }}>Google Cloud</Card.Title>
                <Typography variant="body2" sx={serviceSubtitleSx}>
                  Googleのクラウドプラットフォーム
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={serviceDescriptionSx}>
              Compute Engine、Cloud SQL、Kubernetesなど、GCP環境の監視・運用に対応。
              <br />
              Googleの最新技術を活用したシステムの安定稼働をサポートします。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={serviceItemSx}>
            <Box sx={serviceHeaderSx}>
              <Box sx={{ ...serviceLogoSx, ...nativeLogoSx } as SxProps<Theme>}>Native</Box>
              <Box>
                <Card.Title sx={{ marginBottom: "4px" }}>クラウドネイティブ</Card.Title>
                <Typography variant="body2" sx={serviceSubtitleSx}>
                  各種クラウドネイティブ環境
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={serviceDescriptionSx}>
              Docker、Kubernetes、マイクロサービスアーキテクチャなど、現代的なクラウドネイティブ環境の運用に対応。
              <br />
              DevOpsやCI/CDパイプラインの運用もサポートします。
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const serviceItemSx: SxProps<Theme> = {
  height: "100%",
};

const serviceHeaderSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  width: "100%",
};

const serviceLogoSx: SxProps<Theme> = {
  width: "50px",
  height: "50px",
  marginRight: "15px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  fontWeight: "bold",
};

const awsLogoSx: SxProps<Theme> = {
  background: "#ff9900",
};

const azureLogoSx: SxProps<Theme> = {
  background: "#0078d4",
};

const gcpLogoSx: SxProps<Theme> = {
  background: "#4285f4",
};

const nativeLogoSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #667eea, #764ba2)",
};

const serviceSubtitleSx: SxProps<Theme> = {
  color: "#666",
  fontSize: "0.9rem",
};

const serviceDescriptionSx: SxProps<Theme> = {
  color: "#555",
  fontSize: "0.95rem",
  lineHeight: 1.6,
};
